import { Component, h, Prop, State } from '@stencil/core';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import { has } from 'lodash';
import '../header-component/header-component';
import '../loader-component/loader-component'

/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/carousel-headline-component.PNG)

#### Content Type
nypwebc_ct_announcements
*/

@Component({
  tag: 'carousel-headline-component',
  styleUrl: 'carousel-headline-component.css',
  // shadow: true,
  scoped: true
})
export class CarouselHeadlineComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
*Optional - To show/hide header. default is true
*/
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;

  /**
*Optional - To show see All 
*/
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All link - defaul is this.webpath + "/pages/allitems.aspx"
 */
  @Prop() seeallurl: string = "";

  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string ="See All";



  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"

    /**
  *Optional -thumbnail indicator yes or no
  */
  @Prop() thumbnailindicators: boolean= false


   /**
*Optional - is it SP Online site
*/
@Prop() online: boolean = false;



/**
*Required - site url if its sp online site
*/
@Prop() siteurl: string = "";


  @State() items: [];
  @State() isLoading: boolean = true;

  componentDidLoad() {


    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }


    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }


    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    const filter = "nypwebc_Active eq 1 and nypwebc_headline eq 1";


    // return fetch(siteUrl + this.webpath + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_Active,nypwebc_JobTitle,FileLeafRef,nypwebc_ItemOrder,nypwebc_ReadMore&$filter=" + filter + "&$orderby=nypwebc_ItemOrder", { headers: { "Accept": "application/json; odata=verbose" } })
    return fetch(siteUrl +  "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ShortDescription,nypwebc_ItemOrder,nypwebc_ImageUrl,nypwebc_ReadMore,nypwebc_PostedDate,nypwebc_Body&$filter=" + filter + "&$orderby=nypwebc_ItemOrder", { headers: { "Accept": "application/json; odata=verbose" } })

      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }


  getCarouselIndicatorsPlain = () => {

    const carouselIndicators = [];
    let hashComponentId = "#" + this.componentid;
    this.items.forEach((item: any, index) => {

      if (index === 0) {
        carouselIndicators.push(

          <li data-bs-target={hashComponentId} data-bs-slide-to={index} class="active" aria-current="true" aria-label={item.Title}></li>


        )
      }
      else {
        carouselIndicators.push(
          <li  data-bs-target={hashComponentId} data-bs-slide-to={index}  aria-current="true" aria-label={item.Title}></li>)
      }
    });
    return carouselIndicators
  }

  getCarouselIndicators = () => {

    const carouselIndicators = [];
    let hashComponentId = "#" + this.componentid;
    this.items.forEach((item: any, index) => {

      if (index === 0) {
        carouselIndicators.push(

          <button type="button" data-bs-target={hashComponentId} data-bs-slide-to={index} class="active" aria-current="true" aria-label={item.Title}>
            <img src={item.nypwebc_ImageUrl} class="d-block w-100" />

          </button>
        )
      }
      else {
        carouselIndicators.push(
          <button type="button" data-bs-target={hashComponentId} data-bs-slide-to={index} aria-label={item.Title}>
            <img src={item.nypwebc_ImageUrl} class="d-block w-100" />

          </button>)
      }
    });
    return carouselIndicators
  }

  getCarouselItems = () => {

    const carouselItems = [];

    this.items.forEach((item: any, index) => {
      let readMoreUrl = this.webpath + "/Pages/NewsItem.aspx?listname=" + this.listname + "&webpath=" + this.webpath + "&newsid=" + item.ID
      if (item.nypwebc_ReadMore) {
        readMoreUrl = item.nypwebc_ReadMore
      }

      if (index === 0) {
        carouselItems.push(<div class="carousel-item active"> <div class="card">
          <a href={readMoreUrl} target= "_blank"  data-interception="off" id={item.ID} rel="noopener noreferrer" >
            <div class="row" >
              <div class="col-md-6" >
                <img src={item.nypwebc_ImageUrl} class=" img-fluid mx-auto rounded d-block" />
              </div>
              <div class="col-md-6" >

                <div class="slide-title">{item.Title}</div>
                <div >
                  {item.nypwebc_ShortDescription}

                  {/* {readMoreElement} */}
                </div>
              </div>
            </div>
          </a>
          </div>
        </div>)
      }
      else {
        carouselItems.push(<div class="carousel-item"> <div class="card">
          <a href={readMoreUrl} target= "_blank"  data-interception="off" id={item.ID} rel="noopener noreferrer" ><div class="row" >
            <div class="col-md-6" >
              <img src={item.nypwebc_ImageUrl} class="img-fluid mx-auto rounded d-block" />
            </div>
            <div class="col-md-6" >

              <div class="slide-title">{item.Title}</div>
              <div>
                {item.nypwebc_ShortDescription}
              </div>
              {/* {readMoreElement} */}

            </div>
          </div>
          </a>
          </div>
        </div>)
      }
    });
    return carouselItems
  }


  render() {
    let allNewsUrl = this.webpath + "/pages/allitems.aspx"
    if (this.seeallurl) {
      allNewsUrl = this.seeallurl

    }

    let hashComponentId = "#" + this.componentid;


    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }


    return (

      this.isLoading ? <loader-component /> :

        this.header && this.items.length > 0  ?

          <div>

            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seeallurl={allNewsUrl} seealltitle={this.seealltitle} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
                <div id={this.componentid} class="carousel carousel-dark carousel-fade " data-bs-ride="carousel" style={{ margin: "30px" }} >
                  {/* <div class="carousel-indicators" style={{ bottom: "-40px" }}>
                    {this.getCarouselIndicators()}
                  </div> */}
                  <div class="carousel-inner">

                    {this.getCarouselItems()}

                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target={hashComponentId} data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target={hashComponentId} data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                  {this.thumbnailindicators ? 
                <div class="carousel-indicators" style={{ bottom: "-40px" }}>
                { this.thumbnailindicators?this.getCarouselIndicators():this.getCarouselIndicatorsPlain()}
                </div>
                :
                <div class="carousel-indicators" style={{ bottom: "-40px"}}>
                { this.thumbnailindicators?this.getCarouselIndicators():this.getCarouselIndicatorsPlain()}
                </div>
  }
                </div>

              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle} >
            <div style={style}>
              <div id={this.componentid} class="carousel carousel-dark slide" data-bs-ride="carousel" style={{ margin: "30px" }} >
                {/* <div class="carousel-indicators" style={{ bottom: "-40px" }}>
                  {this.getCarouselIndicators()}
                </div> */}
                <div class="carousel-inner">

                  {this.getCarouselItems()}

                </div>
                <button class="carousel-control-prev" type="button" data-bs-target={hashComponentId} data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target={hashComponentId} data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">Next</span>
                </button>
                {this.thumbnailindicators ? 
                <div class="carousel-indicators" style={{ bottom: "-40px" }}>
                { this.thumbnailindicators?this.getCarouselIndicators():this.getCarouselIndicatorsPlain()}
                </div>
                :
                <div class="carousel-indicators" style={{ bottom: "-40px" }}>
                { this.thumbnailindicators?this.getCarouselIndicators():this.getCarouselIndicatorsPlain()}
                </div>
  }
              </div>


            </div>
          </div>
    )

  }

}
